import _readOnlyError from "@babel/runtime/helpers/esm/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toErrors } from '../../../../../../util/instUIMessages';
import t from '@instructure/quiz-i18n/es/format-message';
import { FormFieldGroup, TextInput } from '@instructure/quiz-common';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
var WordBankCorrectAnswer = /*#__PURE__*/function (_Component) {
  function WordBankCorrectAnswer() {
    var _this;
    _classCallCheck(this, WordBankCorrectAnswer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WordBankCorrectAnswer, [].concat(args));
    _defineProperty(_this, "handleBlankTextChange", function (event) {
      var value = event.target.value;
      _this.props.updateScoringDataForBlank({
        scoringData: _objectSpread(_objectSpread({}, _this.props.scoringDataForBlank), {}, {
          value: value,
          blankText: value
        })
      });
    });
    return _this;
  }
  _inherits(WordBankCorrectAnswer, _Component);
  return _createClass(WordBankCorrectAnswer, [{
    key: "errors",
    value: function errors() {
      var errors = (this.props.scoringDataErrors.value || {}).$errors;
      return toErrors(errors || []);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FormFieldGroup, {
        name: "correct_answer_for_".concat(this.props.blankName),
        rowSpacing: "small",
        description: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Correct Answer'))
      }, /*#__PURE__*/React.createElement(TextInput, {
        renderLabel: t('Possible Choices'),
        isRequired: true,
        defaultValue: this.props.scoringDataForBlank.blankText,
        onChange: this.handleBlankTextChange,
        messages: this.errors()
      }));
    }
  }]);
}(Component);
_defineProperty(WordBankCorrectAnswer, "propTypes", {
  blankName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  scoringDataErrors: PropTypes.shape({
    value: PropTypes.shape({
      $errors: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  scoringDataForBlank: PropTypes.shape({
    blankText: PropTypes.string
  }).isRequired,
  updateScoringDataForBlank: PropTypes.func.isRequired
});
_defineProperty(WordBankCorrectAnswer, "defaultProps", {
  disabled: false,
  scoringDataErrors: {}
});
export { WordBankCorrectAnswer as default };